import { useSelector } from 'react-redux';
import fm from 'format-message';
import { skiplinksThemes } from 'config/branding/component-themes/skiplinks-theme';
import headerHeights from 'config/branding/header-heights';
import SkiplinksMenu from '@activebrands/core-web/components/SkiplinksMenu';
import { styled } from '@activebrands/core-web/libs/styletron';
import { LayoutProps } from '@activebrands/core-web/types/layout';
import Header from 'components/Header';
import Banner from 'components/Header/Banner';

const Wrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100dvh',
});

const Main = styled('main', ({ $hasBanner }) => ({
    flex: '1 0 auto',
    scrollMarginTop: 'var(--height-header)',
}));

const CheckoutLayout = ({ children, page = {} }: LayoutProps) => {
    const banner = page.data?.content?.banner?.[0] || {};
    const bannerTexts = banner?.texts?.map(text => text?.richText || text);
    const backToSiteLabel = page.data?.content?.backToSiteLabel;
    const hasBanner = bannerTexts?.length > 0;
    const { bannerHeight, headerHeight } = headerHeights;
    const dynamicBannerHeight = hasBanner ? bannerHeight : 0;
    const basketItems = useSelector((state: any) => state.basket.items);
    const numberOfItems = basketItems?.reduce((sum, item) => (sum += item.quantity), 0);
    const isEmptyCheckoutView = numberOfItems < 1;

    // Add extra styling for banner if there is only one text
    const bannerStyling = {
        flipClockItemStyle: { whiteSpace: 'wrap' },
        flipClockWrapperStyle: { height: 'auto', padding: '8px', gap: '12px' },
    };

    // Banner styling
    type BannerStyling = { flipClockItemStyle?: any; flipClockWrapperStyle?: any };
    const bannerStyle: BannerStyling = bannerTexts?.length === 1 ? bannerStyling : {};

    return (
        <Wrapper $style={{ paddingTop: `${headerHeight + dynamicBannerHeight}px` }}>
            <SkiplinksMenu
                links={[{ label: fm('Skip to checkout form'), target: '#main' }]}
                $style={{ ...skiplinksThemes.default.menu, ...{ scrollMarginTop: '52px' } }}
                linkStyle={skiplinksThemes.default.link}
            />
            <Header
                isCheckout
                isEmptyCheckout={isEmptyCheckoutView}
                backToSiteLabel={backToSiteLabel}
                theme="default"
            />
            {hasBanner && (
                <Banner
                    $flipClockItemStyle={bannerStyle?.flipClockItemStyle}
                    $flipClockWrapperStyle={bannerStyle?.flipClockWrapperStyle}
                    spin={banner?.spin}
                    texts={bannerTexts}
                    theme={banner?.theme}
                    to={banner.link?.url}
                />
            )}
            <Main
                role="main"
                id="main"
                tabIndex={-1}
                $hasBanner={hasBanner}
                $style={{ scrollMarginTop: 'var(--height-header)' }}
            >
                {children}
            </Main>
        </Wrapper>
    );
};

export default CheckoutLayout;
